import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type VolumeProps = {
    className?: string;
};

const Volume: FC<VolumeProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'volume'}
            viewBox="0 0 20 20"
        >
            <path d="M0 5.879v7.048h5.6l7.072 3.656V2.223L5.6 5.879H0zm11.952-2.472v11.992l-6.024-3.112a.685.685 0 00-.328-.08H.72V6.599H5.6a.664.664 0 00.328-.08l6.024-3.112z" />
            <path d="M15.616 9.398c-.016-1.184-.552-2.272-1.384-2.832l-.4.6c.64.432 1.048 1.288 1.064 2.24-.016.944-.424 1.8-1.064 2.24l.4.6c.832-.576 1.368-1.656 1.384-2.848z" />
            <path d="M17.808 9.399c-.032-1.816-.84-3.48-2.112-4.336l-.4.6c1.08.728 1.768 2.16 1.8 3.743-.024 1.576-.712 3.016-1.8 3.744l.4.6c1.272-.871 2.08-2.527 2.112-4.351z" />
            <path d="M20 9.399c-.04-2.52-1.16-4.824-2.928-6.016l-.4.6C18.24 5.03 19.24 7.11 19.28 9.399c-.04 2.288-1.04 4.368-2.616 5.432l.4.6c1.768-1.192 2.888-3.496 2.928-6.024v-.008H20z" />
        </svg>
    );
};

export default Volume;
